export default {
  app: {
    place: {
      address: '地址',
      showOnExternalMaps: '在Google地圖呈現',
    },
  },
};
